module.exports = __webpack_public_path__ + "img/diesel-locomotive-shadow-02.457cef8e.png";